var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.FormHelper,{ref:"formHelper",attrs:{"form":_setup.form,"config":_setup.computedConfig},model:{value:(_setup.customFunction),callback:function ($$v) {_setup.customFunction=$$v},expression:"customFunction"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }